import script from "./HistoryChart.vue?vue&type=script&setup=true&lang=ts"
export * from "./HistoryChart.vue?vue&type=script&setup=true&lang=ts"

import "./HistoryChart.vue?vue&type=style&index=0&id=737e838c&scoped=true&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-737e838c"]])

export default __exports__